import config from '../config';
import convertObjectToFormData from "../utils/convertObjectToFormData";

export async function getCategories(type, token) {
    const response = await fetch(`${config.API_URL}/category/all?category_type=${type}`, {
        method: 'GET',
        headers: {
            'Authorization': `Bearer ${token}`,
        }
    })
    if (response.status !== 200) {
        throw Error('Failed to update');
    }
    const data = await response.json();
    // console.log(type+": list :",data)
    return data;
}

export async function fetchCategoryTree(type, token) {
    const response = await fetch(`${config.API_URL}/category/tree?category_type=${type}`, {
        method: 'GET',
        headers: {
            'Authorization': `Bearer ${token}`,
        }
    })
    if (response.status !== 200) {
        throw Error('Failed to update');
    }
    const data = await response.json();
    // console.log(type+": tree :",data)
    return data;
}


export async function fetchTraitsByCategory(categoryId, type, token) {
    // We need to convert the JSON object to FormData so that we can attach image
    const formData = convertObjectToFormData({ id: categoryId, type: type })

    const res = await fetch(`${config.API_URL}/category/traits`, {
        method: 'post',
        headers: {
            'Authorization': `Bearer ${token}`,
            'Accept': 'application/json, text/plain, */*'
        },
        body: formData
    });

    if (res.status !== 200) {
        throw Error('Failed to update');
    }

    const body = await res.json();
    // console.log(body)
    return body;
}

export async function fetchBranchTraits(token) {
    // We need to convert the JSON object to FormData so that we can attach image

    const res = await fetch(`${config.API_URL}/branch/traits`, {
        method: 'post',
        headers: {
            'Authorization': `Bearer ${token}`,
            'Accept': 'application/json, text/plain, */*'
        },
        body: {}
    });

    if (res.status !== 200) {
        throw Error('Failed to update');
    }

    const body = await res.json();
    console.log(body)
    return body;
}

export async function requestCategory(newCategory, token, providerId) {
    const formData = convertObjectToFormData(newCategory)

    const res = await fetch(`${config.API_URL}/category/request`, {
        method: 'post',
        headers: {
            'Authorization': `Bearer ${token}`,
            'Accept': 'application/json, text/plain, */*',
            providerId: providerId
        },
        body: formData
    });

    if (res.status !== 200) {
        throw Error('Failed to update');
    }

    const body = await res.json();
    return body;
}